module.exports = __webpack_public_path__ + "08_face.91dc9040.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer1/08_face.png
// module id = JNSV
// module chunks = 0